export default "__VITE_ASSET__CeiAc95H__"